import type { Components, Theme } from '@mui/material';

export const typographyCustomizations: Components<Theme> = {
  MuiTypography: {
    styleOverrides: {
      gutterBottom: {
        marginBottom: 12,
      },
    },
  },
};
